import React from 'react';
import Waves from '../components/waves';
import Navigation from '../components/navigation';
import Cta from '../components/cta';
import Footer from '../components/footer';

import structural1 from '../images/structural1.png';
import structural4 from '../images/structural4.png';
import structural5 from '../images/structural5.png';
import structural6 from '../images/structural6.png';
import structural7 from '../images/structural7.png';

import '../css/typography.css';
import check from "../images/check.svg";

const Treatments = () => {
    const listItem = (icon, text) => {
        return (
            <div className="flex flex-no-wrap items-center">
                <img className="max-h-8 md:max-h-11 pr-2 md:pr-4" src={icon} alt="cross" />
                {text}
            </div>
        )
    }

    return (
        <body className="leading-normal tracking-normal text-white gradient">
            <Navigation />
            <div className="pt-4">
                <Waves />
            </div>

            <section className="py-6 bg-white text-gray-800">
                <div className="container max-w-4xl mx-auto m-8">

                    <div className="flex flex-wrap justify-center py-10 md:py-20">
                        <div className="md:w-1/3 px-8">
                            <h3 className="text-3xl text-gray-800 font-bold mb-3">The 3-Series Structural Bodywork Experience</h3>
                        </div>
                        <div className="md:w-2/3 px-8">
                            <p>Over the past 2 years, Dario has trained with <b className="boldStyle">Anatomy Trains</b> toward becoming a <b className="boldStyle">Certified Anatomy Trains Structural Integrator (ATSI)</b>. Each session builds upon the last to uncover the underlying causes of chronic tension, imbalance, or discomfort that may have been overlooked before.</p><br/>
                            <p>Contact us directly via <a href="mailto:info@mexiabodywork.com" className="underline">email</a> to begin your Structural Bodywork journey.</p>
                        </div>
                    </div>

                </div>
            </section>

            <section className="bg-gray-100 py-6 bg-white text-gray-800">
                <div className="container max-w-5xl mx-auto m-8">

                    <div className="flex flex-wrap justify-center py-10 md:py-20">
                        <div className="w-full md:w-1/2 px-8">
                            <h3 className="text-2xl md:text-3xl text-gray-800 font-bold mb-3">What You Can Expect</h3>
                            <p className="text-gray-600 mb-12">Before your first session, we’ll go through a detailed intake to understand your history, habits, and goals. During sessions, you’ll typically wear comfortable coverage (such as underwear or a two-piece swimsuit) so we can observe movement and alignment.</p>
                            <p className="text-gray-600 mb-12">You’ll be asked to stand, walk, or perform simple movements during the session to assess functional and structural restrictions and track patterns.</p>
                        </div>
                        <div className="w-full md:w-1/2 px-8">
                            <img className="imageFilter rounded-lg" src={structural1} />
                        </div>
                    </div>

                    <div className="flex flex-wrap justify-center py-10 md:py-20">
                        <div className="w-full md:w-1/2 px-8">
                            <h3 className="text-2xl md:text-3xl text-gray-800 font-bold mb-3">How The Work Feels</h3>
                            <p className="text-gray-600 mb-12">Structural Bodywork involves slow, intentional hands-on work. Your practitioner uses hands, fingers, and forearms to work through fascial layers while guiding you in small movements.</p>
                            <p className="text-gray-600 mb-12">Many describe it as a “good hurt” — a release of long-held tension that feels productive and freeing. Open communication ensures you receive maximum benefit while staying within your comfort level.</p>
                        </div>
                        <div className="w-full md:w-1/2 px-8">
                            <img className="imageFilter rounded-lg" src={structural4} />
                        </div>
                    </div>
                </div>
            </section>

            <section className="py-6 bg-white text-gray-800">
                <div className="container max-w-5xl mx-auto">

                    <div className="flex flex-wrap justify-center items-center py-10 md:py-5">
                        <h3 className="my-2 text-lg sm:text-xl text-center text-gray-800">The 3 Sessions</h3>
                        <div className="w-full mb-8">
                            <div className="h-1 mx-auto gradient w-64 opacity-25 my-0 py-0 rounded-t" />
                        </div>

                        <div className="md:w-2/3 px-8 pt-10 sm:pt-0">
                            <p>Each session addresses a different fascial territory or structural relationship:</p><br/>

                            <h3>Session 1 — The Lower Body</h3>
                            <ul className="list-disc list-inside">
                                <li>Focus: Feet, knees, and hips.</li>
                                <li>Goal: Establish grounding and support from the feet up.</li>
                                <li>Territory: foot to 12th rib</li>
                            </ul><br/>

                            <h3>Session 2 — The Upper Body</h3>
                            <ul className="list-disc list-inside">
                                <li>Focus: Rib cage and shoulder girdle.</li>
                                <li>Goal: Improve breath, ease of movement, and shoulder mobility.</li>
                                <li>Territory: lesser trochanter to hands</li>
                            </ul><br/>

                            <h3>Session 3 — The Spine and Curves</h3>
                            <ul className="list-disc list-inside">
                                <li>Focus: Flexion, extension, sidebending, and rotation.</li>
                                <li>Goal: Integrate the whole body through balanced curves and core support.</li>
                                <li>Territory: spine & its guy-wires</li>
                            </ul><br/>

                        </div>
                    </div>

                    <div className="flex flex-wrap justify-center items-stretch -mx-4">
                        <div className="w-full sm:w-1/3 px-4 mb-2">
                            <img className="imageFilter rounded-lg mx-auto max-h-96" alt="back pain" src={structural5} />
                        </div>

                        <div className="w-full sm:w-1/3 px-4 mb-2">
                            <img className="imageFilter rounded-lg mx-auto max-h-96" alt="back pain" src={structural6} />
                        </div>

                        <div className="w-full sm:w-1/3 px-4 mb-2">
                            <img className="imageFilter rounded-lg mx-auto max-h-96" alt="back pain" src={structural7} />
                        </div>
                    </div>
                </div>
            </section>

            <section className="bg-gray-100 border-t border-b text-gray-800">
                <div className="container max-w-5xl mx-auto">

                    <div className="flex flex-wrap justify-center py-10 md:py-20">
                        <div className="md:w-2/3 px-8">


                            <h3 className="my-2 text-lg sm:text-xl text-center text-gray-800">Think of It as a Project</h3>
                            <div className="w-full mb-8">
                                <div className="h-1 mx-auto gradient w-64 opacity-25 my-0 py-0 rounded-t" />
                            </div>
                            <p>Each 3-Series has a clear beginning, middle, and end — a structured process rather than ongoing therapy. By the end, you’ll have a deeper awareness of your body and how to maintain these changes long after your sessions.</p><br/>
                            <p>This service is dual-purpose:</p><br/>
                            <ul className="checks">
                                <li>{listItem(check, "Helping clients improve posture, movement & long-term patterns")}</li>
                                <li>{listItem(check, "Completing required hands-on Structural Integration clinical hours")}</li>
                            </ul>
                            <p>Photos may be requested for educational review with <b className="boldStyle">Anatomy Trains</b> faculty and practitioners. No images are ever used publicly without signed consent.</p><br/>


                            <h3 className="my-2 text-lg sm:text-xl text-center text-gray-800">What to Wear</h3>
                            <div className="w-half mb-8">
                                <div className="h-1 mx-auto gradient w-64 opacity-25 my-0 py-0 rounded-t" />
                            </div>
                            <ul className="list-disc list-inside">
                                <li>Shorts / yoga or running shorts</li>
                                <li>Sports bra for females</li>
                                <li>No shirt for males</li>
                                <li>Draping is not used in this work</li>
                            </ul><br/>


                            <h3 className="my-2 text-lg sm:text-xl text-center text-gray-800">Other Things to Know</h3>
                            <div className="w-half mb-8">
                                <div className="h-1 mx-auto gradient w-64 opacity-25 my-0 py-0 rounded-t" />
                            </div>
                            <ul className="list-disc list-inside">
                                <li>Sessions must scheduled 2 weeks apart</li>
                                <li>Limited after-hours spots available for serious clients</li>
                                <li>ATSI Structural Bodywork Series: 3 × 75-min sessions $540</li>
                                <li>Contact us directly via <a href="mailto:info@mexiabodywork.com" className="underline">email</a> to book your session</li>
                            </ul><br/>
                        </div>
                    </div>

                </div>

            </section>

            <Cta />
            <Footer />
        </body>
    )
}

export default Treatments;

